import { render, staticRenderFns } from "./ComplexCarousel.vue?vue&type=template&id=e2aa6ba2&lang=pug&"
import script from "./ComplexCarousel.vue?vue&type=script&lang=js&"
export * from "./ComplexCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports